<script lang="ts">
    import ButtonMenu from '$components/ButtonMenu/ButtonMenu.svelte';
    import MenuLink from '$components/ButtonMenu/MenuLink.svelte';
    import { type NewsFeedPostFragment } from '$gql/graphql.js';
    import { cx } from '$lib/utils/cx.js';
    import CreateFeedPostModal, { createModal } from './CreateFeedPostModal.svelte';
    import { participantToInput } from '$lib/utils/participantUtils';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    export let post: NewsFeedPostFragment;
    export let className: string = '';

    const currentUser = getContainer().currentUserStore().currentUser();
    const { lang } = getContainer();

    const modal = createModal({ defaultOpen: false });

    let actions = {
        share_on_my_profile: {
            type: 'async' as const,
            action: async () => {
                modal.states.open.set(true);
                return {
                    type: 'success' as const,
                };
            },
        },
        share_link: {
            type: 'async' as const,
            action: async () => {
                try {
                    await navigator.share({
                        url: post.url,
                        text: t.feed_post.default_share_text({}, $lang),
                    });
                    return {
                        type: 'success' as const,
                    };
                } catch {
                    await navigator.clipboard.writeText(post.url);
                    return {
                        type: 'success' as const,
                        toast: {
                            message: t.feed_post.link_copied_to_clipboard({}, $lang),
                        },
                    };
                }
            },
        },
    };
</script>

<ButtonMenu
    class={cx(
        'bg-transparent border-none hover:bg-gray-200 cursor-pointer py-[12px] px-[14px] text-black rounded-full focus:outline-none focus:ring-2 focus:ring-brand-blue inline-flex items-center',
        className,
    )}
    {actions}
>
    <span slot="button">
        <i aria-hidden={true} class={'fa fa-share fa-lg mr-3'} />
        <span class={'hidden ls:inline'}>
            {t.feed_post.button_to_share({}, $lang)}
        </span>
    </span>
    <svelte:fragment slot="menu">
        <MenuLink
            icon="fa fa-pencil-square-o"
            label={t.feed_post.share_on_my_profile({}, $lang)}
            key="share_on_my_profile"
        />
        <MenuLink icon="fa fa-external-link" label="Partager le lien" key="share_link" />
    </svelte:fragment>
</ButtonMenu>

{#if $currentUser != null}
    <CreateFeedPostModal
        sharedPostId={post.id}
        initialAuthor={participantToInput($currentUser)}
        title={t.feed_post.share_on_my_profile({}, $lang)}
        {modal}
    />
{/if}
